import { Alert, LinearProgress } from '@mui/joy';

import { useParams } from 'react-router-dom';

import Breadcrumbs from '@/components/Breadcrumbs';
import { useRun } from '@/hooks/useSwr';

import Header from '../../components/CodeHeader';
import { RunsPlayground } from '../Playground/RunsPlayground';

export default function PublicRunPlayground() {
  const { datasetShareToken, runId } = useParams();
  const publicRun = useRun({
    id: runId,
    shareToken: { datasetShareToken },
    withContents: true,
  });

  return (
    <div className="flex h-screen flex-col">
      <div className="px-4 pt-3">
        <Breadcrumbs />

        {publicRun.isLoading && <LinearProgress />}

        {publicRun.error && (
          <>
            <Header text="Error" copy={publicRun.error?.message} />
            <Alert color="danger" variant="outlined" sx={{ marginBottom: 3 }}>
              {publicRun.error?.message}
            </Alert>
          </>
        )}
      </div>
      {publicRun.data && publicRun.contents?.inputs.data && (
        <RunsPlayground run={publicRun.data} />
      )}
    </div>
  );
}
